const styObj = {
  default: {
    '--page-color01': '#fffbf5',
    '--page-color02': '#fffaf0',
    '--page-color03': '#ffe5ad',
    '--page-color04': '#ffe5ad',
    '--page-color05': '#5f656a',
    '--page-color06': '#202326',
    '--page-color07': '#0c0e11',
    '--page-color08': 'rgba(255, 255, 255, 0.8)',
    '--page-color09': '#8e9092',
    '--page-color10': 'rgba(255, 255, 255, 0.8)',
    '--page-color11': '#202326',
    '--page-color12': '#ffb94d',
    '--page-color13': '#202326',
    '--page-color14': '#ffa433',
    '--page-color15': '#ffd00b',
    '--page-color16': '#f59d4d',
    '--page-color17': '#ffffff',
    '--page-color18': '#222222',
    '--page-color19': '#8e9092',
    '--page-color20': '#8e9092',
    '--page-color21': '#999999',
    '--page-color22': '#8e9092',
    '--page-color23': '#202326',
    '--page-color24': '#ffa433',
    '--page-color25': '#fff4d6',
    '--page-color26': '#8e9092',
    '--page-color27': '#202326',
    '--page-color28': '#8e9092',
    '--page-color29': '#ffa433',
    '--page-font01': 'Roboto-Regular',
    '--page-font02': 'Roboto-Regular',
    '--page-font03': 'Roboto-Regular',
    '--page-font04': 'Roboto-Regular',
    '--page-font05': 'Outfit-Regular',
    '--page-font06': 'Roboto-Regular',
    '--page-font07': 'Outfit-Regular',
    '--page-font08': 'Outfit-Medium',
    '--page-font09': 'Inter-Regular',
    '--page-font10': 'Roboto-Regular',
    '--page-font11': 'Roboto-Regular',
    '--page-font12': 'Roboto-Regular',
    '--page-font13': 'Roboto-Regular',
    '--page-font14': 'Roboto-Regular',
    '--page-font15': 'Roboto-Regular',
    '--page-font16': 'Roboto-Regular',
    '--page-radius01': '30px',
    '--icon-bg-1': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/bg-1.png')})`,
    '--icon-h-first': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-first.png')})`,
    '--icon-h-second': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-second.png')})`,
    '--icon-h-third': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-third.png')})`
  },
  joyu: {
    '--page-color01': '#FFFBF5',
    '--page-color02': '#fffaf0',
    '--page-color03': '#FFD3BB',
    '--page-color04': '#ffd7c1',
    '--page-color05': '#5f656a',
    '--page-color06': '#0C0E11',
    '--page-color07': '#0c0e11',
    '--page-color08': 'rgba(255, 255, 255, 0.8)',
    '--page-color09': '#8e9092',
    '--page-color10': 'rgba(255, 255, 255, 0.8)',
    '--page-color11': '#0C0E11',
    '--page-color12': '#FF997F',
    '--page-color13': '#0C0E11',
    '--page-color14': '#FF6A55',
    '--page-color15': '#ffd00b',
    '--page-color16': '#f59d4d',
    '--page-color17': '#ffffff',
    '--page-color18': '#222222',
    '--page-color19': '#8e9092',
    '--page-color20': '#8e9092',
    '--page-color21': '#999999',
    '--page-color22': '#8E9092',
    '--page-color23': '#0C0E11',
    '--page-color24': '#FF6A55',
    '--page-color25': '#FFECDD',
    '--page-color26': '#8e9092',
    '--page-color27': '#0C0E11',
    '--page-color28': '#8e9092',
    '--page-color29': '#FF6A55',
    '--page-font01': 'NotoSans-Regular',
    '--page-font02': 'NotoSans-Regular',
    '--page-font03': 'NotoSans-Regular',
    '--page-font04': 'NotoSans-Regular',
    '--page-font05': 'NotoSans-Regular',
    '--page-font06': 'NotoSans-Regular',
    '--page-font07': 'NotoSans-Regular',
    '--page-font08': 'NotoSans-Regular',
    '--page-font09': 'NotoSans-Regular',
    '--page-font10': 'NotoSans-Regular',
    '--page-font11': 'NotoSans-Regular',
    '--page-font12': 'NotoSans-Regular',
    '--page-font13': 'NotoSans-Regular',
    '--page-font14': 'NotoSans-Regular',
    '--page-font15': 'NotoSans-Regular',
    '--page-font16': 'NotoSans-Regular',
    '--page-radius01': '4px',
    '--icon-bg-1': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/joyu/bg-1.png')})`,
    '--icon-h-first': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-first.png')})`,
    '--icon-h-second': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-second.png')})`,
    '--icon-h-third': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-third.png')})`
  },
  vibeo: {
    '--page-color01': '#fffbf5',
    '--page-color02': '#fffaf0',
    '--page-color03': '#ffe5ad',
    '--page-color04': '#ffe5ad',
    '--page-color05': '#5f656a',
    '--page-color06': '#202326',
    '--page-color07': '#0c0e11',
    '--page-color08': 'rgba(255, 255, 255, 0.8)',
    '--page-color09': '#8e9092',
    '--page-color10': 'rgba(255, 255, 255, 0.8)',
    '--page-color11': '#202326',
    '--page-color12': '#ffb94d',
    '--page-color13': '#202326',
    '--page-color14': '#ffa433',
    '--page-color15': '#ffd00b',
    '--page-color16': '#f59d4d',
    '--page-color17': '#ffffff',
    '--page-color18': '#222222',
    '--page-color19': '#8e9092',
    '--page-color20': '#8e9092',
    '--page-color21': '#999999',
    '--page-color22': '#8e9092',
    '--page-color23': '#202326',
    '--page-color24': '#ffa433',
    '--page-color25': '#fff4d6',
    '--page-color26': '#8e9092',
    '--page-color27': '#202326',
    '--page-color28': '#8e9092',
    '--page-color29': '#ffa433',
    '--page-font01': 'Roboto-Regular',
    '--page-font02': 'Roboto-Regular',
    '--page-font03': 'Roboto-Regular',
    '--page-font04': 'Roboto-Regular',
    '--page-font05': 'Outfit-Regular',
    '--page-font06': 'Roboto-Regular',
    '--page-font07': 'Outfit-Regular',
    '--page-font08': 'Outfit-Medium',
    '--page-font09': 'Inter-Regular',
    '--page-font10': 'Roboto-Regular',
    '--page-font11': 'Roboto-Regular',
    '--page-font12': 'Roboto-Regular',
    '--page-font13': 'Roboto-Regular',
    '--page-font14': 'Roboto-Regular',
    '--page-font15': 'Roboto-Regular',
    '--page-font16': 'Roboto-Regular',
    '--page-radius01': '30px',
    '--icon-bg-1': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/bg-1.png')})`,
    '--icon-h-first': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-first.png')})`,
    '--icon-h-second': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-second.png')})`,
    '--icon-h-third': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-third.png')})`
  },
  whonow: {
    '--page-color01': '#fffbf5',
    '--page-color02': '#fffaf0',
    '--page-color03': '#D7EE9A',
    '--page-color04': '#D7EE9A',
    '--page-color05': '#5f656a',
    '--page-color06': '#202326',
    '--page-color07': '#0c0e11',
    '--page-color08': 'rgba(255, 255, 255, 0.8)',
    '--page-color09': '#8e9092',
    '--page-color10': 'rgba(255, 255, 255, 0.8)',
    '--page-color11': '#0C0E11',
    '--page-color12': '#C7E77E',
    '--page-color13': '#0C0E11',
    '--page-color14': '#9FD957',
    '--page-color15': '#ffd00b',
    '--page-color16': '#f59d4d',
    '--page-color17': '#ffffff',
    '--page-color18': '#222222',
    '--page-color19': '#8e9092',
    '--page-color20': '#8e9092',
    '--page-color21': '#999999',
    '--page-color22': '#8E9092',
    '--page-color23': '#0C0E11',
    '--page-color24': '#9FD957',
    '--page-color25': '#EAF5C8',
    '--page-color26': '#8e9092',
    '--page-color27': '#0C0E11',
    '--page-color28': '#8e9092',
    '--page-color29': '#9FD957',
    '--page-font01': 'Manrope-Regular',
    '--page-font02': 'Manrope-Regular',
    '--page-font03': 'Manrope-Regular',
    '--page-font04': 'Manrope-Regular',
    '--page-font05': 'Manrope-Regular',
    '--page-font06': 'Manrope-Regular',
    '--page-font07': 'Manrope-Regular',
    '--page-font08': 'Manrope-Regular',
    '--page-font09': 'Manrope-Regular',
    '--page-font10': 'Manrope-Regular',
    '--page-font11': 'Manrope-Regular',
    '--page-font12': 'Manrope-Regular',
    '--page-font13': 'Manrope-Regular',
    '--page-font14': 'Manrope-Regular',
    '--page-font15': 'Manrope-Regular',
    '--page-font16': 'Manrope-Regular',
    '--page-radius01': '30px',
    '--icon-bg-1': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/whonow/bg-1.png')})`,
    '--icon-h-first': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-first.png')})`,
    '--icon-h-second': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-second.png')})`,
    '--icon-h-third': `url(${require('@/assets/packageAssets/views/P1_Girls/HostessIncomeRank/default/h-third.png')})`
  }
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        }
        // 未配置
        else {
          return styObj['default']
        }
      }
      return {}
    }
  }
}
